import { render } from "./VuetableFieldHandle.vue?vue&type=template&id=19ccd6b0"
import script from "./VuetableFieldHandle.vue?vue&type=script&lang=js"
export * from "./VuetableFieldHandle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__